import { MutationTree } from 'vuex'

import {
  Contract,
  Mutations,
  ServiceRequest,
  UserDetails,
  UserState,
} from './types'

const mutations: MutationTree<UserState> = {
  [Mutations.SET_USER_DETAILS]: (state, userDetails: UserDetails) => {
    state.userDetails = userDetails
  },

  [Mutations.SET_EMAIL_PENDING_VERIFICATION]: (state, isVerified: boolean) => {
    state.isEmailPendingVerification = !isVerified
  },

  [Mutations.SET_SERVICE_REQUEST]: (state, serviceRequest: ServiceRequest) => {
    state.serviceRequest = serviceRequest
  },

  [Mutations.SET_CONTRACT]: (state, contract: Contract) => {
    state.contract = contract
  },

  [Mutations.SET_IS_PASSWORD_SET]: (state, isPasswordSet: boolean) => {
    state.isPasswordSet = isPasswordSet
  },

  [Mutations.SET_IS_ONE_TIME_LOGIN_SESSION]: (
    state,
    isOneTimeLoginSession: boolean,
  ) => {
    state.isOneTimeLoginSession = isOneTimeLoginSession
  },
}

export default mutations
